import { useEffect, useState } from 'react';
import Image from 'next/image';
import classNames from '@/lib/misc/classNames';
import { fallbackLogo } from '@/lib/misc/tokenImageHelper';
import { Skeleton } from '../ui/skeleton';
interface Props {
  fallback?: string;
  src: string;
  alt: string;
  width: number;
  height: number;
  [key: string]: any;
}
//removed memo - react compiler should handle this
const ImageWithFallback = ({
  fallback = fallbackLogo,
  src,
  alt,
  width,
  height,
  ...props
}: Props) => {
  src = src?.replace('https://www.tradegenius.com/', '/');
  const [imgSrc, setImgSrc] = useState(() => src ? src?.startsWith('http://') || src?.startsWith('https://') ? `/api/proxy-image?url=${encodeURIComponent(src)}` : src : null);
  useEffect(() => {
    if (src) {
      const newSrc = src?.startsWith('http://') || src?.startsWith('https://') ? `/api/proxy-image?url=${encodeURIComponent(src)}` : src;
      setImgSrc(newSrc);
    }
  }, [src]);
  useEffect(() => {
    if (!src || !imgSrc) {
      setImgSrc(fallback);
    }
  }, []);
  const handleError = () => {
    setImgSrc(fallback);
  };
  return <div className={classNames('relative overflow-hidden', props.className)} style={{
    width,
    height,
    minWidth: width,
    minHeight: height
  }} data-sentry-component="ImageWithFallback" data-sentry-source-file="ImageWithFallback.tsx">
      {imgSrc ? imgSrc.includes('.svg') ? <img alt={alt} src={imgSrc} width={width} height={height} onError={handleError} {...props} className='absolute top-0 left-0' loading='eager' /> : <Image alt={alt} src={imgSrc} width={width} height={height} onError={handleError} {...props} className='absolute top-0 left-0' loading='eager' priority /> : <Skeleton className='rounded-full' style={{
      width: `${width}px`,
      height: `${height}px`
    }} />}
    </div>;
};
export default ImageWithFallback;
ImageWithFallback.displayName = 'ImageWithFallback';